export default __webpack_public_path__ + "static/media/03AW4NOV65.52f5dddf.jpg";